import React, { useState } from "react";
import { useTranslation } from 'react-i18next';
import { FaArrowRight, FaBullseye, FaColumns, FaMagic, FaCommentDots } from 'react-icons/fa';
import { HiCheckCircle } from 'react-icons/hi';
import { useApp } from '../../../context/AppContext';
import "./SalesPageNew.css";

const PRICING = {
   GBP: { symbol: "£", monthly: "29", annually: "25" },
   USD: { symbol: "$", monthly: "29", annually: "25" },
   EUR: { symbol: "€", monthly: "29", annually: "25" },
   SEK: { symbol: " kr", monthly: "400", annually: "333", suffix: true },
   AUD: { symbol: "AU$", monthly: "49", annually: "46" },
   CAD: { symbol: "CA$", monthly: "49", annually: "46" },
   NZD: { symbol: "NZ$", monthly: "60", annually: "54" },
};


const hubItemKeys = [
   { emoji: "🏪", key: "customStorefront" },
   { emoji: "♾️", key: "unlimitedProducts" },
   { emoji: "📱", key: "customerApps" },
   { emoji: "🎓", key: "unlimitedCourses" },
   { emoji: "📦", key: "unlimitedDigitalProducts" },
   { emoji: "♻️", key: "unlimitedSubscriptions" },
   { emoji: "🤝", key: "unlimitedCoaching" },
   { emoji: "👥", key: "unlimitedCommunities" },
   { emoji: "💬", key: "messaging" },
   { emoji: "📈", key: "insights" },
   { emoji: "💸", key: "instantPayouts" },
   { emoji: "😎", key: "customerAdmin" },
   { emoji: "🎟️", key: "promoCodes" },
   { emoji: "💌", key: "unlimitedEmails" },
   { emoji: "💳", key: "bnpl" },
   { emoji: "🌐", key: "customDomain" },
   { emoji: "✨", key: "customBranding" },
   { emoji: "💰", key: "affiliates" },
   { emoji: "🖥️", key: "landingPages" },
   { emoji: "🙋", key: "realHumanSupport" },
   { emoji: "🏷️", key: "zeroCommission" },
];

const agentGroupDefs = [
   {
      bucketKey: "findClients",
      jobs: [
         { Icon: FaBullseye, key: "runMetaAds" },
         { Icon: FaColumns, key: "buildLandingPages" },
      ],
   },
   {
      bucketKey: "convertVisitors",
      jobs: [
         { Icon: FaMagic, key: "createContent" },
         { Icon: FaCommentDots, key: "findConvertVisitors" },
      ],
   },
];

export default function HubVsAgents({ windowWidth, logged_in, pre_influencer, influencer_bool, current_user, utmSource, utmMedium, utmCampaign, utmTerm, utmContent, referralId, passiveReferralId }) {
   const { t } = useTranslation();
   const { currency } = useApp();
   const [billing, setBilling] = useState('annually');

   const price = PRICING[currency] || PRICING.USD;
   const amount = billing === 'annually' ? price.annually : price.monthly;
   const isMobile = windowWidth < 768;
   const isSmall = windowWidth < 640;
   const isLarge = windowWidth >= 1024;

   const buildRegisterUrl = () => {
      let url = '/become-a-creator';
      if (referralId) url += '?id=' + referralId;
      else if (passiveReferralId) url += '?passive_id=' + passiveReferralId;
      const utms = { utm_source: utmSource, utm_medium: utmMedium, utm_campaign: utmCampaign, utm_content: utmContent, utm_term: utmTerm };
      Object.entries(utms).forEach(([k, v]) => { if (v) url += (url.includes('?') ? '&' : '?') + k + '=' + v; });
      return url;
   };

   const handleCTA = () => {
      if (logged_in === true) {
         if (pre_influencer === true && influencer_bool !== true) {
            window.location.assign('/become-a-creator/start-free-trial');
         } else if (pre_influencer === false && influencer_bool !== true) {
            window.location.assign(buildRegisterUrl());
         } else {
            window.location.assign('/' + current_user);
         }
      } else {
         const el = document.getElementById('hero-social-input');
         if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(() => el.focus(), 500); return; }
         window.location.assign(buildRegisterUrl());
      }
   };

   return (
      <section id="how" style={{ maxWidth: 1152, margin: '0 auto', padding: '80px 24px' }}>
         <div style={{
            display: 'grid',
            gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
            gap: 24,
            alignItems: 'start',
            alignContent: 'start',
         }}>
            {/* HUB CARD */}
            <div id="pricing" className="sp-card-lift" style={{
               borderRadius: 24, border: '1px solid var(--sp-bg-soft-2)', background: '#fff',
               padding: isMobile ? 24 : 32, scrollMarginTop: 96,
            }}>
               <h3 style={{ fontSize: isMobile ? 30 : 36, fontWeight: 700, letterSpacing: '-0.02em', color: 'var(--sp-ink)' }}>
                  {t('salesPageNew.hub.title')}
               </h3>
               <p style={{ marginTop: 12, color: 'var(--sp-text-soft)', fontSize: 16, lineHeight: 1.7, textTransform: 'none', fontWeight: 400 }}>
                  {t('salesPageNew.hub.description')}
               </p>

               {/* Billing toggle */}
               <div style={{ marginTop: 24, display: 'flex', alignItems: 'center', gap: 8 }}>
                  <div style={{
                     display: 'inline-flex', alignItems: 'center', borderRadius: 999,
                     backgroundColor: '#F5F9FF', padding: 4, boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.06)',
                  }}>
                     <button
                        type="button"
                        onClick={() => setBilling('monthly')}
                        style={{
                           border: 'none', cursor: 'pointer', borderRadius: 999,
                           padding: '6px 16px', fontSize: 14, fontWeight: 600,
                           transition: 'all 0.2s',
                           backgroundColor: billing === 'monthly' ? '#fff' : 'transparent',
                           color: billing === 'monthly' ? 'var(--sp-ink, #1a1a2e)' : 'var(--sp-text-soft, #6b7280)',
                           boxShadow: billing === 'monthly' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                        }}
                     >
                        {t('salesPageNew.hub.monthly')}
                     </button>
                     <button
                        type="button"
                        onClick={() => setBilling('annually')}
                        style={{
                           border: 'none', cursor: 'pointer', borderRadius: 999,
                           padding: '6px 16px', fontSize: 14, fontWeight: 600,
                           transition: 'all 0.2s',
                           backgroundColor: billing === 'annually' ? '#fff' : 'transparent',
                           color: billing === 'annually' ? 'var(--sp-ink, #1a1a2e)' : 'var(--sp-text-soft, #6b7280)',
                           boxShadow: billing === 'annually' ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
                        }}
                     >
                        {t('salesPageNew.hub.annually')}
                     </button>
                  </div>
               </div>

               {/* Price */}
               <div style={{ marginTop: 16, display: 'flex', alignItems: 'baseline', gap: 8, whiteSpace: 'nowrap' }}>
                  <span style={{
                     fontSize: isSmall ? 36 : (isMobile ? 48 : (isLarge ? 72 : 48)),
                     fontWeight: 800, letterSpacing: '-0.02em', lineHeight: isLarge ? 1 : 1.1,
                     color: 'var(--sp-ink)', transition: 'opacity 0.2s',
                  }}>
                     {price.suffix ? `${amount}${price.symbol}` : `${price.symbol}${amount}`}
                  </span>
                  <span style={{ fontSize: isSmall ? 12 : (isMobile ? 14 : (isLarge ? 18 : 13)), color: 'var(--sp-text-soft)' }}>
                     {billing === 'annually' ? t('salesPageNew.hub.billedAnnually') : t('salesPageNew.hub.perMonth', '/month')}
                  </span>
               </div>

               {/* Features list */}
               <ul style={{
                  marginTop: 32, display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr',
                  gap: '16px 24px', listStyle: 'none', padding: 0,
               }}>
                  {hubItemKeys.map(it => (
                     <li key={it.key} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                        <span style={{ fontSize: 18, lineHeight: '24px' }}>{it.emoji}</span>
                        <span style={{ fontSize: 14, fontWeight: 600, color: 'var(--sp-ink)', textTransform: 'none' }}>{t(`salesPageNew.hub.features.${it.key}`)}</span>
                     </li>
                  ))}
               </ul>

               {/* CTA */}
               <button
                  onClick={handleCTA}
                  style={{
                     marginTop: 32, display: 'block', width: '100%', borderRadius: 12,
                     background: 'var(--sp-brand)', padding: '16px 24px', textAlign: 'center',
                     fontSize: 16, fontWeight: 600, color: '#fff', border: 'none', cursor: 'pointer',
                     transition: 'background 0.2s',
                  }}
                  onMouseOver={e => e.currentTarget.style.background = 'var(--sp-brand-dark)'}
                  onMouseOut={e => e.currentTarget.style.background = 'var(--sp-brand)'}
               >
                  {t('salesPageNew.hub.startTrial')}
               </button>
            </div>

            {/* AGENTS CARD */}
            <div className="sp-card-lift" style={{
               borderRadius: 24, border: '1px solid #FFD8B8', padding: 32,
               background: 'linear-gradient(180deg, #FFF6EE, #FFFFFF)',
               position: isMobile ? 'relative' : 'sticky', top: isMobile ? 'auto' : 96,
            }}>
               <p className="sp-eyebrow">{t('salesPageNew.agents.eyebrow')}</p>
               <h3 style={{ marginTop: 8, fontSize: isMobile ? 48 : 60, letterSpacing: '-0.02em', color: 'var(--sp-ink)' }}>
                  {t('salesPageNew.agents.title')}{" "}
                  <span className="sp-accent-italic-agent">{t('salesPageNew.agents.titleAccent')}</span>
               </h3>
               <p style={{ marginTop: 12, color: 'var(--sp-text-soft)', fontSize: 16, lineHeight: 1.7, textTransform: 'none', fontWeight: 400 }}>
                  {t('salesPageNew.agents.description')}
               </p>

               <div style={{ marginTop: 24, display: 'flex', flexDirection: 'column', gap: 24 }}>
                  {agentGroupDefs.map(group => (
                     <div key={group.bucketKey}>
                        <p className="sp-eyebrow">{t(`salesPageNew.agents.${group.bucketKey}`)}</p>
                        <ul style={{ marginTop: 12, display: 'flex', flexDirection: 'column', gap: 12, listStyle: 'none', padding: 0 }}>
                           {group.jobs.map(it => (
                              <li key={it.key} style={{ display: 'flex', alignItems: 'center', gap: 12, color: 'var(--sp-ink)' }}>
                                 <span style={{
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    width: 36, height: 36, borderRadius: 12, background: '#fff',
                                    color: 'var(--sp-agent-ad)', boxShadow: 'inset 0 0 0 1px #FFD8B8',
                                 }}>
                                    <it.Icon size={18} />
                                 </span>
                                 <span style={{ fontSize: 14, fontWeight: 500, textTransform: 'none', lineHeight: 1.4 }}>{t(`salesPageNew.agents.${it.key}`)}</span>
                              </li>
                           ))}
                        </ul>
                     </div>
                  ))}
               </div>
            </div>
         </div>
      </section>
   );
}
